import { useLocation, useNavigate } from 'react-router-dom'
import { Home, Search, Calendar, ShoppingCart, Heart } from 'lucide-react'
import { cn } from '@/lib/utils'

interface TabItem {
  path: string
  label: string
  icon: React.ElementType
  /** Match these paths as "active" too (e.g. /recipes/:id → Descubrir) */
  matchPaths?: string[]
}

const tabs: TabItem[] = [
  {
    path: '/dashboard',
    label: 'Inicio',
    icon: Home,
  },
  {
    path: '/recipes',
    label: 'Descubrir',
    icon: Search,
    matchPaths: ['/recipes/'],
  },
  {
    path: '/meal-planner',
    label: 'Planificar',
    icon: Calendar,
  },
  {
    path: '/shopping-list',
    label: 'Compras',
    icon: ShoppingCart,
  },
  {
    path: '/favorites',
    label: 'Favoritos',
    icon: Heart,
  },
]

export function BottomTabBar() {
  const location = useLocation()
  const navigate = useNavigate()

  const isActive = (tab: TabItem) => {
    if (location.pathname === tab.path) return true
    if (tab.matchPaths?.some((p) => location.pathname.startsWith(p))) return true
    return false
  }

  return (
    <nav
      className="fixed bottom-0 inset-x-0 z-50 bg-white border-t border-gray-200 lg:hidden"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      <div className="flex items-center justify-around h-16">
        {tabs.map((tab) => {
          const active = isActive(tab)
          const Icon = tab.icon

          return (
            <button
              key={tab.path}
              onClick={() => navigate(tab.path)}
              className={cn(
                'flex flex-col items-center justify-center w-full h-full gap-0.5',
                'transition-colors duration-200 touch-manipulation active:scale-95',
                active
                  ? 'text-primary'
                  : 'text-gray-400 hover:text-gray-600',
              )}
            >
              <Icon
                className={cn(
                  'h-5 w-5 transition-all duration-200',
                  active && 'scale-110',
                )}
                strokeWidth={active ? 2.5 : 2}
              />
              <span
                className={cn(
                  'text-[10px] leading-tight',
                  active ? 'font-semibold' : 'font-medium',
                )}
              >
                {tab.label}
              </span>
            </button>
          )
        })}
      </div>
    </nav>
  )
}
